// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Time: MarkdocTagRegistration = {
  tag: 'time',
  component: 'Time',
  selfClosing: true,
  attributes: {
    at: {
      type: String,
      description:
        "Give a specific timestamp, like '2008-11-21T20:00:51.000Z'. Use with 'format' attribute.",
    },
    plus: {
      type: String,
      description:
        'Give a time delta, for example 3 years, to get 3 years from the current time.',
    },
    minus: {
      type: String,
      description:
        'Give a time delta, for example 2 hours, to get 2 hours before the current time.',
    },
    startOf: {
      type: String,
      description:
        'Give a time unit, for example `month`. We will pin this time to the start of that unit.',
    },
    format: {
      type: String,
      description:
        "A format string. Can be 'date','full-date','full-date-withweekday','time','time-with-seconds','date-time','full-date-time','year','iso','iso-date','iso-time' ,'unix', or 'unix-milliseconds'",
    },
    timezone: {type: String, description: 'A timezone, like UTC-7.'},
  },
};
